import { Link, Text } from '@lego/klik-ui';
import { Link as ReactRouterLink } from 'react-router-dom';
import { UserNameLink } from '@/components/common/UserNameLink';
import type { DeploymentResponse } from '@/hooks/deployment';
import { dateTimeFormat } from '@/utility/date';
import { paths } from '@/utility/global_paths';
import { PlaceholderText } from '../../PlaceholderText';
import { createColumnHelper } from '../appTable';

const columnHelper = createColumnHelper<DeploymentResponse>();

export const getDeploymentTableColumns = (workspaceId: number) =>
  columnHelper.columns([
    columnHelper.accessor('id', {
      cell: (info) => (
        <Text fontFamily="mono" fontSize="sm">
          {info.getValue()}
        </Text>
      ),
      header: 'ID',
      meta: { filterVariant: { constraint: /^[0-9]*$/, type: 'singleSearch' } },
      size: 96,
    }),
    columnHelper.accessor('applicationVersionId', {
      cell: (info) => {
        const versionId = info.getValue();
        const applicationId = info.row.original.applicationId;
        return versionId != null && applicationId != null ? (
          <Link
            as={ReactRouterLink}
            p={0}
            to={paths.applicationVersionById(workspaceId, applicationId, versionId)}
          >
            {versionId}
          </Link>
        ) : (
          <PlaceholderText>{versionId ?? 'No application version'}</PlaceholderText>
        );
      },
      header: 'Application Version ID',
      id: 'applicationVersion',
      meta: {
        filterVariant: { constraint: /^[0-9]*$/, type: 'singleSearch' },
      },
      size: 64,
    }),
    columnHelper.accessor('files', {
      cell: (info) => {
        const files = info.getValue();
        return files.length > 0 ? `${files.length}` : <PlaceholderText>No files</PlaceholderText>;
      },
      enableSorting: false,
      header: 'Number of files',
      size: 160,
    }),
    columnHelper.accessor('createdByOid', {
      cell: (info) => <UserNameLink oid={info.getValue()} />,
      enableSorting: false,
      header: 'Created By',
    }),
    columnHelper.accessor('createdAt', {
      cell: (info) => new Date(info.getValue()).toLocaleString(dateTimeFormat.local),
      header: 'Created At',
      meta: { filterVariant: { type: 'dateRange' } },
      size: 128,
    }),
  ]);
